import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import Transition from './transition'
import { StaticQuery, graphql } from 'gatsby'
import './layout.css'

const Layout = ({ children, location }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <Helmet
          title={data.site.siteMetadata.title}
          meta={[
            { name: 'A personal portfolio for Luis M Castañeda', content: 'Luis M Castañeda' },
            { name: 'keywords', content: 'portfolio, software, engineering' },
          ]}
        >
          <html lang="en" />
        </Helmet>
        <div>
            <Transition location={location}>{children}</Transition>
        </div>
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout